// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from 'react';
import './ClaimImageView.scss';
import { useTranslation } from 'react-i18next';
import { storage } from '../../context/firebase';

import { fetchImageUrl, loadImageData } from '../../shared_components/utils/ImgUtils';
import PropertyField from '../PropertyField/PropertyField';
import LoadingIcon from '../LoadingIcon/LoadingIcon';
import SwipeableContainer from '../SwipeableContainer/SwipeableContainer';

// Importing icons
import back_icon from '../../assets/icons/white/back_small.png';
import notes_icon from '../../assets/icons/white/document.png';
import CommonModal from '../../shared_components/CommonModal/CommonModal';

export default function ClaimImageView({
  claimImage,
  onClose,
  handleClaimImageChange,
  getNextImage,
  getPrevImage,
  deleteImage,
}) {
  const { t } = useTranslation();
  const [image, setImage] = React.useState(null);
  const [showDeletePopup, setShowDeletePopup] = React.useState(false);

  React.useEffect(() => {
    /* Fetch the image URL and load the image */
    async function loadImage() {
      const imageUrlAuth = await fetchImageUrl(storage, claimImage?.image_storage_path);
      const img = await loadImageData(imageUrlAuth);
      setImage(img.src);
    }

    if (claimImage?.image_storage_path) {
      setImage(null);
      loadImage();
    }
  }, [claimImage?.image_storage_path]);

  return (
    <div className='image-view'>
      <SwipeableContainer className='image-container' onSwipeLeft={getPrevImage} onSwipeRight={getNextImage}>
        <img className='main-image' src={image} style={{ display: image ? 'block' : 'none' }} />
      </SwipeableContainer>
      <button className='back-button' onClick={onClose}>
        <img src={back_icon} />
      </button>

      <button className='scroll-button prev' onClick={getPrevImage}>
        <img src={back_icon} />
      </button>

      <button className='scroll-button next' onClick={getNextImage}>
        <img src={back_icon} />
      </button>

      <button
        className='delete-button'
        onClick={() => {
          setShowDeletePopup(true);
        }}
      >
        {t('general_delete')}
      </button>

      <div className='loading-icon' style={{ display: image ? 'none' : 'block' }}>
        <LoadingIcon />
      </div>

      <div className='image-properties'>
        <PropertyField
          icon={notes_icon}
          title={t('property_notes')}
          value={claimImage.notes}
          name='notes'
          type='textarea'
          handleChange={handleClaimImageChange}
          editable={true}
        />
      </div>

      {/* Delete Image Popup Modal */}
      <CommonModal
        show={showDeletePopup}
        title={t('delivery_confirm_delete_image')}
        confirmText={t('general_delete')}
        cancelText={t('general_cancel')}
        onConfirm={deleteImage}
        onCancel={() => setShowDeletePopup(false)}
        theme='dark'
        topCloseButton
        variant='danger'
        containerClassName='text-center'
      >
        {t('delivery_confirm_delete_image_description')}
      </CommonModal>
    </div>
  );
}
